<template>
  <div class="custom-s-menu">
  <div class="list-items nav">
    <ul class="list-ul">
      <li class="list-li" v-for="(item,index) in items" @click="setclickItem(item.id);children=item.children;parent=item.id ; showSub(item.id,index+1) ; oldid=item.id ;  ">
        <div  :class="['item',{'activeBtn': (item.id == currentIndex || item.id == parent)   ,'active-home-icon' : item.id == currentIndex }]" >
          <div class="item-icon-container" v-if="index===0">
            <img  v-if="logoType ==='img' "  class="item-icon"  :src="item.logo" />
            <span  class="item-span" v-else >
              <svg  class="home-icon"  width="18px" height="17px" viewBox="0 0 18 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g  stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <path class="custom-home-icon" d="M8.83749392,3.90872878 C8.94357131,3.90872878 9.04610094,3.94235541 9.13050589,4.00358054 L9.19018346,4.05457992 L15.0955676,9.88628728 C15.1707456,9.96009547 15.2194446,10.0552533 15.2356398,10.1573676 L15.2415977,10.2350327 L15.2415977,14.4884227 C15.2415977,15.436651 14.5022149,16.2143188 13.5618099,16.289715 L13.4117329,16.295706 L10.487091,16.295706 L10.487091,11.8231279 L7.18707186,11.8231279 L7.18707186,16.295706 L4.25912992,16.295706 C3.29905603,16.295706 2.51167335,15.5654497 2.43533527,14.636648 L2.42926933,14.4884227 L2.42926933,10.2350327 C2.42926933,10.1304254 2.4628809,10.0292356 2.5242015,9.94554968 L2.57529518,9.88628728 L8.48480437,4.05457992 C8.57784381,3.96127039 8.70489717,3.90872878 8.83749392,3.90872878 Z M6.98989572,0.73172081 C7.97802413,-0.201488339 9.51000419,-0.24206265 10.545424,0.609997878 L10.6834421,0.73172081 L12.6832537,2.70685825 L12.6832537,1.64758487 C12.6832537,1.09361544 13.1379447,0.644534505 13.6988345,0.644534505 C14.2223317,0.644534505 14.6533179,1.0357339 14.7084561,1.53829148 L14.7144154,1.64758487 L14.7144154,4.71132941 L17.399806,7.36358699 C17.6580322,7.61795791 17.758158,7.98744631 17.664117,8.33368432 C17.5700759,8.67992233 17.2961551,8.95030815 16.9455378,9.04299007 C16.6387477,9.12408675 16.3140195,9.05834842 16.065745,8.87078393 L15.9642977,8.78301332 L9.2487588,2.15033231 C9.04312819,1.95792091 8.73399024,1.93654187 8.505358,2.08619518 L8.42375402,2.15033231 L1.70986517,8.78219849 C1.30977243,9.1523431 0.684459533,9.14207607 0.297044857,8.75900134 C-0.0605686905,8.4053939 -0.0963225232,7.85194657 0.195420103,7.45842688 L0.275181865,7.36358699 L6.98989572,0.73172081 Z"  fill="#000000" fill-rule="nonzero"></path>
                    </g>
               </svg>
            </span>
          </div>
          <div class="item-icon-container" v-if="index !== 0">
            <img  v-if="logoType ==='img' "  class="item-icon"  :src="item.logo" />
            <span  class="item-span" v-else v-html="item.logoSvg"></span>
          </div>
          <div class="item-name title-menu"> {{item.title}} </div>
          <span v-if="item.children && item.children.length > 1" style="margin-right: 10px;">
            <svg :class="[{'activeIcon': ( item.id == currentIndex || item.id == parent  ) && showSubMenu  , 'notActiveIcon': (item.id !== currentIndex  || item.id !== parent ) && !showSubMenu   }]"  width="15px" height="11px" viewBox="0 0 19 11" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g  stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g transform="translate(-660.000000, -192.000000)" class="color-fill-expend"  :class="[{'color-fill': (item.id == currentIndex  || item.id == parent )    }]" fill="#000000" fill-rule="nonzero">
                <g  transform="translate(0.000000, 105.000000)">
                  <g transform="translate(202.000000, 0.000000)">
                    <g  transform="translate(457.000000, 87.000000)">
                      <path d="M18.132,0.778 L10.373,8.539 L2.615,0.777 C2.24293482,0.419847143 1.65348351,0.42609371 1.28907072,0.791051213 C0.924657931,1.15600872 0.919291806,1.7454687 1.277,2.117 L9.7,10.546 L9.7,10.546 C9.87711431,10.7236415 10.1176495,10.8234839 10.3685,10.8234839 C10.6193505,10.8234839 10.8598857,10.7236415 11.037,10.546 L19.464,2.116 C19.7173766,1.88038432 19.821909,1.52523771 19.7365764,1.18992773 C19.6512437,0.854617749 19.3896609,0.592643362 19.054479,0.506809237 C18.719297,0.420975113 18.3639944,0.524976153 18.128,0.778 L18.132,0.778 Z" ></path>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </svg>
          </span>
        </div>
      </li>
    </ul>
  </div>
    <div class="sub nav sub-m"  v-show="  (showSubMenu && children && children.length > 0 && showSubMenu ) ">
      <ul class="list-ul">
        <li class="list-li" v-for="(sub, subindex) in children" @click="clickItem(sub.id) ;">
          <div  :class="['item',{'activeBtn': sub.id == currentIndex}]"  >
            <div class="item-name text-sous-menu " :class="[{'active-sous-menu': sub.id == currentIndex}]"> {{sub.title}} </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'CustomMenu',
    data() {
      return {
        parent:'',
        oldid:'',
        children: [],
        showSubMenu:false,
        themeId:''

      }},
    props:{
      clickItem: Function,
      items:{
        type: Array,
      },
      currentIndex: String,
      logoType:{
        type : String,
        default: 'svg'
      }
    },
    methods: {
      showSub(id,index){
        if(this.oldid != id ) {
          this.showSubMenu=true
          return
        }
          if(id===index){
          this.showSubMenu = ! this.showSubMenu
        }
      },
      setclickItem(id){
        const themeId = this.$route.params.themeId;
        if(id !=themeId )
        this.clickItem(id);
      },
  },
    mounted() {
      this.parent = this.$route.params.themeId;
    }

  };
</script>

<style scoped lang="scss">
  .list-items{
    width:var(--list-items-width,100%);
    height: var(--list-items-height,auto);
    background-color: var(--list-items-bg-color,#f9f9f9);
    font-family: var(--list-items-font-family, sans-serif );
  }
  .list-ul {
    list-style-type: none;
    overflow: hidden;
    margin: var(--list-ul-margin,0%);
    padding: var(--list-ul-padding,0%);
    background-color: var(--list-items-list-ul-bg-color,#f9f9f9);
    width: var(--list-items-list-ul-width,100%);
    vertical-align: middle;
  }
  .list-li {
    height: 100%;
    display:var(--list-items-list-li-display,inline-block);
   // width: calc(100% /(var(--list-number-items,6.5)));
  }
  .item{
    float: left;
    text-align:  var(--list-items-item-text-align,center);
    padding: var(--list-items-item-padding,16px);
    font-size: var(--list-items-item-font-size,1.15vw);
    height: var(--list-items-item-height,100%);
    margin: var(--list-items-item-margin,4%);
    border-radius:var(--list-items-item-border-radius,5px);
    width: var(--list-items-item-width,100%) ;
    color:var(--list-items-item-name-color,#6e6e6e) ;
    transition:var(--list-items-item-transition, all 0.2s);
    display: flex;
    align-items: center;

    padding-right: 1em;
    padding-left: 1em;
  }
  .item-icon-container{
    float: left;
    width: var(--list-items-item-icon-container-width,30%) ;
    height:  var(--list-items-item-icon-container-height,100%) ;
    padding: var(--list-items-item-icon-container-padding,0%);
    margin: var(--list-items-item-icon-container-margin,0%);
  }
  .item-icon{
    width: var(--list-items-item-icon-width,100%) ;
    height: var(--list-items-item-icon-height,100%) ;
    padding: var(--list-items-item-icon-padding,0%);
    margin: var(--list-items-item-icon-margin,0%);
  }
  .item-name{
    float: left;
    width:var(--list-items-item-name-width,70%) ;
    margin: var(--list-items-item-name-margin, 9%);
    padding: var(--list-items-item-name-padding,0%);
  }

  .item:hover {
    background-color: var(--list-items-item-over, #e3e3e3);
    cursor: pointer;
    color: var(--list-items-item-over-textcolor, #fff);
    fill: var(--list-items-item-hover-fillsvg, #fff);
  }
  .activeBtn {
    background-color: var(--list-items-item-active, #e3e3e3);
    fill:  var(--list-items-item-active-fillsvg,  #fff);
  }
  .nav li {
    &:hover {
      .submenu {
        display: block;
      }
    }
    .submenu {
      display:none;
      position:absolute;
      width:inherit;
      text-align:left;
      min-width: 100%;
      padding-top: 0;
      color: #ffffff;
      font-weight: 700;
      font-size: 0.9rem;
      top: 100%;
      box-shadow: 1px 2px 3px 0px rgba(0, 0, 0, 0.2);
      z-index: 1;
      ul {
        background-color: var(--list-items-bg-color,#f9f9f9);
        position: relative;
        padding: 0;
        li {
          display: block;
          float:none !important;
          height:auto;
          line-height:32px;
          cursor: pointer;
          padding: 0 5px;
          &:hover {
            background-color: rgba(255, 255, 255, .5);
          }
          &:not(:last-child) {
            border-bottom: 1px solid rgba(255, 255, 255, 0.4);
          }
          a {
            color: #ffffff;
            &:hover {
              text-decoration: none;
              color: #ffffff;
            }
          }
        }
      }
    }
  }

  .text-sous-menu{
    cursor: pointer;
    font-family: Raleway;
    font-size: 15px;
    font-weight: normal!important;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #000000;
  }
  .custom-s-menu{
    width: 100%;
  }
  .title-menu{
    cursor: pointer;
    font-family: Raleway;
    font-size: 17px;
    font-weight: normal!important;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #000000;
    :hover{
      .color-fill{
        fill: var(--secondary-color);
      }
    }
  }

  .text-sous-menu:hover{
    color: var(--secondary-color ) !important;
  }

  .list-li:hover{
    .color-fill-expend{
    fill: var(--secondary-color ) !important;
    }
    .item-name{
      color:  var(--secondary-color ) !important;
    }
  }
  .home-icon:hover{
   .custom-home-icon {
     fill:  var(--secondary-color ) !important;
   }
  }
  .active-home-icon{
    .custom-home-icon {
      fill:  var(--secondary-color ) !important;
    }
  }

.active-sous-menu{
  color: var(--secondary-color ) !important;
}
.activeIcon{
  transform: rotate(180deg) !important;
}
.notActiveIcon{
  transform: rotate(0deg);

}
</style>



// WEBPACK FOOTER //
// src/components/Custom/CustomMenu.vue